
export class BonusVO {
    public static BONUS_CHIPS: number = 1;
    public static BONUS_CHIPS_XP: number = 2;
    public static BONUS_CHIPS_GOLD: number = 3;

    public bonusType: number = NaN;

    public chips: number = NaN;
    public xp: number = NaN;
    public gold: number = NaN;

    constructor(chips: number, xp: number, gold: number) {
        this.chips = chips;
        this.xp = xp;
        this.gold = gold;

        this.setBonusType(chips, xp, gold);
    }

    private setBonusType(chips: number, xp: number, gold: number): void {
        this.bonusType = 1;

        if (chips) {
            this.bonusType = 1;
        }
        if (chips && xp) {
            this.bonusType = 2;
        }
        if (chips && gold) {
            this.bonusType = 3;
        }
    }

    public toString(): string {
        return "chips: " + this.chips + ", xp: " + this.xp + ", gold: " + this.gold + ", bonusType: " + this.bonusType;
    }
}
